import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/promotionBenefit'

export const promotionBenefitService = {
    search,
    saveItem,
    updateItem,
    deleteItem,
    syncFirebase
};

function search(offset, max, dataFilter) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search`, 'POST', { data: dataFilter, showAlert: false})
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data})
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data:data });
}

function deleteItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'DELETE',{});
}


function syncFirebase() {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/syncFirebase`, 'GET', {})
}